export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14412.312f085d.jpg";